<template>
	<page style="background: #fff;">
		<c-form ref="form">
			<c-form-item label="调拨类型" required>
				<c-radio-group name="handover_type" :options="allotTypeOptions"></c-radio-group>
			</c-form-item>
			<c-form-item label="接驳部门" required>
				<c-select v-model="checkDepartment" name="handover_dept_id" async @search="searchDepartment"></c-select>
			</c-form-item>
			<c-form-item label="接驳人员" required>
				<c-select ref="userSelect" name="handover_user_id" :placeholder="!checkDepartment ? '请先选择接驳部门' : '请选择'" :disabled="!checkDepartment" async @search="searchUser"></c-select>
			</c-form-item>
			<c-form-item ref="items" label="调拨商品" name="items" required>
				<template #handle>
					<span style="font-size: .26rem; color: #aaa;"><span style="color: var(--color-main)">{{productList.length}}</span>条记录</span>
				</template>
				<insert-data scan-name="扫码调拨" @scan="scanHandle"></insert-data>
				<detail-card v-for="(item, i) in productList" :key="i" :index="i + 1" remove-button @remove="productList.splice(i, 1)">
					<template #title>
						<span>{{[item.brand_name, item.model_name, item.color_name, item.memory_name].filter(item => item).join(' ')}}</span>
					</template>

					<template #default>
						<c-field label="背贴码">{{item.produce_unique_code}}</c-field>
						<c-field label="当前接驳人">{{item.recipient_user_realname || '-'}}</c-field>
					</template>
				</detail-card>
			</c-form-item>
		</c-form>

		<template #button>
			<c-button color="main" hollow size="form" @click="mp.navigateBack()">取消</c-button>
			<c-button class="foot-button" size="form" color="main" @click="submitHandle">确认调拨</c-button>
		</template>
	</page>
</template>

<script>
	export default {
		props: {
			code: String,
			from: String
		},

		data() {
			return {
				allotTypeOptions: [],
				checkDepartment: '',
				productList: []
			}
		},
		
		computed: {
			allotState() {
				switch (this.from) {
				case '1':
					return 12;

				case '2':
					return 22;

				case '3':
					return 32;

				default:
					return 10;
				}
			}
		},

		watch: {
			//切换接驳部门后清空已选接驳人，防止部门与接驳人不一致
			checkDepartment(val, oldVal) {
				if (val != oldVal) {
					this.$refs.userSelect.set();
				}
			}
		},

		mounted() {
			this.request({
				url: '/dic/info/options',
				data: {
					dic_type_code: 'HANDOVER_TYPE'
				},
				success: data => {
					this.allotTypeOptions = data;
				}
			})
			if (this.code) {
				this.scanHandle(this.code);
			}
		},
		
		methods: {
			searchDepartment(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'DEPARTMENT',
						keyword
					},
					success: resolve
				})
			},

			searchUser(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'SYSUSER',
						department_id: this.checkDepartment,
						keyword
					},
					success: resolve
				})
			},

			scanHandle(code) {
				if (this.productList.some(item => item.produce_unique_code == code)) {
					this.$message({
						message: '该背贴码已存在'
					});
					return;
				}
				this.request({
                    url: '/productCode/access/detail',
                    data: {
                        produce_unique_code: code
                    },
					success: data => {
						if (data.state == this.allotState) {
							this.productList.push(data);
						} else {
							this.$confirm({
								message: `背贴码【${code}】处于非在库状态，无法调拨`,
								type: 'warn',
								buttonName: '我知道了',
								cancelButton: false
							});
						}
					}
				});
			},

			submitHandle() {
				this.$refs.form.submit({
					url: '/handover/batch/add',
					rule: {
						handover_type: '请选择调拨类型',
						handover_dept_id: '请选择接驳部门',
						handover_user_id: '请选择接驳人',
						items: [{
							type: 'function',
							message: '请扫描调拨商品',
							fun: () => {
								return this.productList.length;
							}
						}]
					},
					dataFormatter: data => {
						return Object.assign(data, {
							produce_unique_id_list: this.productList.map(item => item.id)
						})
					},
					success: () => {
						this.mp.redirectWeb('/success/allot');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>